// External imports
import React from 'react';
import { Typography, Paper, Modal, withStyles } from '@material-ui/core';
// Image imports
import termsAndConditionsPDF from '~/public/documents/2026_TS_Online_Terms_of_Service_CrossLink_Online.pdf';
import textingPrivacyPolicyPDF from '~/public/documents/Privacy_Policy_CrossLink_FOC_1.1.2025_v2.pdf';
import textTermsAndConditionsPDF from '~/public/documents/SMS-Messaging-Terms-1.1.2023.pdf';
// Styling imports
import { styles } from '~/app/Pages/TermsAndConditions/css/termsAndConditions.js';

const termsDocumentAssets = require.context('../../../public/documents', false, /\.pdf$/);

const resolveTermsDocument = (documentKey, allowDefault = true) => {
  if (!documentKey) return allowDefault ? termsAndConditionsPDF : null;

  try {
    return termsDocumentAssets(`./${documentKey}`);
  } catch {
    return null;
  }
};

const PreviewTermsAndConditions = props => {
  const { classes } = props;

  let pdf = resolveTermsDocument(props.documentKey, !props.requireDocumentKey);
  if (props?.textlinkPDF === 'textingPrivacyPolicyPDF') {
    pdf = textingPrivacyPolicyPDF;
  } else if (props?.textlinkPDF === 'textTermsAndConditionsPDF') {
    pdf = textTermsAndConditionsPDF;
  } else if (props?.textlinkPDF === 'termsAndConditionsPDF') {
    pdf = resolveTermsDocument(props.documentKey, !props.requireDocumentKey);
  }

  const closePreview = () => props.toggleModal?.(Boolean(pdf));

  return (
    <Modal
      id="previewTermsAndCondtions"
      open={props.isPDFOpen}
      className={classes.modalSpacing}
      onClose={closePreview}
    >
      <Paper className={classes.modal}>
        <Typography variant="body1" className={classes.modalTitle}>
          <span>Terms and Conditions</span>
          <span onClick={closePreview} className="terms-and-conditions-cancel-btn">
            X
          </span>
        </Typography>

        {pdf ? (
          <object
            className="terms-and-conditions-preview-pdf"
            id="termsAndConditionsPDF"
            data={pdf}
          />
        ) : (
          <Typography role="alert" variant="body2">
            The Terms document is not available in this build.
          </Typography>
        )}
      </Paper>
    </Modal>
  );
};

export default withStyles(styles)(PreviewTermsAndConditions);
